import { api } from './api';

export const communityImagesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getCommunityImages: builder.query({
      query: (params = {}) => {
        const { publishStatus: _publishStatus, ...rest } = params;
        return {
          url: '/admin/prompts/community-images',
          params: {
            page: rest.page ?? 1,
            limit: rest.limit ?? 10,
            ...(rest.search && { search: rest.search }),
            ...(rest.sortBy && { sortBy: rest.sortBy }),
            ...(rest.sortOrder && { sortOrder: rest.sortOrder }),
            // Always send is_publish as string when defined so the filter is applied and cache key differs
            ...(rest.is_publish !== undefined && {
              is_publish: rest.is_publish === true ? 'true' : 'false',
            }),
            ...(rest.is_featured !== undefined && {
              is_featured: rest.is_featured === true ? 'true' : 'false',
            }),
            ...(rest.model && { model: rest.model }),
          },
        };
      },
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map(({ id }) => ({ type: 'CommunityImage', id })),
              { type: 'CommunityImage', id: 'LIST' },
            ]
          : [{ type: 'CommunityImage', id: 'LIST' }],
    }),
    getCommunityImageModels: builder.query({
      query: () => ({
        url: '/admin/prompts/community-images/models',
      }),
      providesTags: [{ type: 'CommunityImage', id: 'MODELS' }],
    }),
    toggleCommunityImagePublish: builder.mutation({
      query: (id) => ({
        url: `/admin/prompts/community-images/${id}/toggle-publish`,
        method: 'PATCH',
      }),
      invalidatesTags: (result, error, id) => [
        { type: 'CommunityImage', id },
        { type: 'CommunityImage', id: 'LIST' },
      ],
    }),
    deleteCommunityImage: builder.mutation({
      query: (id) => ({
        url: `/admin/prompts/community-images/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, id) => [
        { type: 'CommunityImage', id },
        { type: 'CommunityImage', id: 'LIST' },
      ],
    }),
    deleteManyCommunityImages: builder.mutation({
      query: (ids) => ({
        url: '/admin/prompts/community-images/bulk-delete',
        method: 'POST',
        body: { ids },
      }),
      invalidatesTags: [{ type: 'CommunityImage', id: 'LIST' }],
    }),
    deleteAllCommunityImages: builder.mutation({
      query: () => ({
        url: '/admin/prompts/community-images',
        method: 'DELETE',
      }),
      invalidatesTags: [{ type: 'CommunityImage', id: 'LIST' }],
    }),
    setFeaturedCommunityImages: builder.mutation({
      query: ({ ids, featured }) => ({
        url: '/admin/prompts/community-images/set-featured',
        method: 'PATCH',
        body: { ids, featured },
      }),
      invalidatesTags: (result, error, { ids }) => [
        ...(ids || []).map((id) => ({ type: 'CommunityImage', id })),
        { type: 'CommunityImage', id: 'LIST' },
      ],
    }),
  }),
});

export const {
  useGetCommunityImagesQuery,
  useGetCommunityImageModelsQuery,
  useToggleCommunityImagePublishMutation,
  useDeleteCommunityImageMutation,
  useDeleteManyCommunityImagesMutation,
  useDeleteAllCommunityImagesMutation,
  useSetFeaturedCommunityImagesMutation,
} = communityImagesApi;
